import React from "react";
import { Link } from "react-router-dom";
import { TestIcon } from "routes/analysis/helpers/analysisHelpers";
import PercentageBar from "components/common/percentageBar";
import UserStatistics from "components/common/userStatistics";
import { BusinessProcess, RuleFunction, RuleTest } from "routes/analysis/types/analysis";

interface TestRowProps {
  test: RuleTest;
  process: BusinessProcess;
  analysisId: string | undefined;
}

const TestRow: React.FC<TestRowProps> = ({ test, process, analysisId }) => (
  <div className="list-row-1">
    <div className="flex items-center p-4 gap-4">
      <div className="basis-12">
        <Link to={`/analysis/${analysisId}/users/test/${test.testId}`}>
          <span className="Appkit4-icon icon-link-outline"></span>
        </Link>
      </div>
      <div className="basis-96">
        <b>{test.identifier}</b>
        <p>{test.functions?.map((m: RuleFunction, index: number) => (
          <span className="ap-function-description" key={test.identifier.concat(index.toString())}>{m.description}</span>
        ))}</p>
      </div>
      <div className="basis-20"><TestIcon type={test.type} /></div>
      <div className="basis-52">
        <PercentageBar percentage={test.stats ? Math.round((test.stats.userCount / process.userTotal) * 100) : 0} dark />
      </div>
      <div>
        <UserStatistics stats={test.stats} comparisonStats={test.comparisonStats} />
      </div>
    </div>
  </div>
);

export default TestRow;
